import { Chip } from '@design-system/components/chip/chip';
import { Typography } from '@design-system/components/typography/typography';
import { KEYWORD_LIMIT, PROFILE_KEYWORDS } from '../../helpers';
import { ProfileVM } from '../../view-model/Profile.viewModel';
import { chipGrid } from './DiscoverySection.css';

type DiscoverySectionProps = {
  vm: ProfileVM;
};

export const DiscoverySection = ({ vm }: DiscoverySectionProps) => {
  const { form } = vm;
  const keywords = form.watch('keywords') ?? [];

  const handleToggle = (keyword: string) => {
    const isSelected = keywords.includes(keyword);

    if (isSelected) {
      form.setValue(
        'keywords',
        keywords.filter((k: string) => k !== keyword),
        { shouldDirty: true },
      );
      return;
    }

    if (keywords.length >= KEYWORD_LIMIT) {
      return;
    }

    form.setValue('keywords', [...keywords, keyword], { shouldDirty: true });
  };

  return (
    <div>
      <div className={chipGrid}>
        {PROFILE_KEYWORDS.map((name) => {
          const isSelected = keywords.includes(name);
          const isAtLimit = keywords.length >= KEYWORD_LIMIT;

          return (
            <Chip
              key={name}
              label={name}
              selected={isSelected}
              disabled={!isSelected && isAtLimit}
              onClick={() => handleToggle(name)}
            />
          );
        })}
      </div>
      <Typography variant="body" size="small" color="N-60">
        {keywords.length} of {KEYWORD_LIMIT} selected
      </Typography>
    </div>
  );
};
